import React from "react";

const UPDATED = "June 2026";
const CONTACT = "support@quiktronic.com";

const PRIVACY = [
  ["What we collect", "When you sign in with Google we receive your name, email address and profile picture. When you order, book a service or sell a device, we store the details you give us: delivery or pickup address, phone number, device details, photos of devices you sell, and your order history."],
  ["How we use it", "To deliver orders, schedule repairs and installations, give buyback quotes and arrange pickups, contact you about your requests, prevent fraud, and improve Quiktronic."],
  ["Who we share it with", "Only with partners needed to complete your request: delivery staff, service technicians, brand dealers and resale buyer partners (for devices you sell). We do not sell your personal data."],
  ["Storage and security", "Your data is stored on secure servers. Device photos are kept in private storage that only Quiktronic staff can view."],
  ["Your choices", `You can ask us to see, correct or delete your data at any time by writing to ${CONTACT}.`],
  ["Google sign-in", "We use Google sign-in only to confirm who you are. We do not read your Gmail, contacts or other Google data."],
  ["Changes", "We may update this policy. The date at the top shows when it last changed."],
];

const TERMS = [
  ["Using Quiktronic", "Quiktronic lets you buy electronics, book repairs and installations, and sell used devices. You must give accurate information and use the service lawfully."],
  ["Orders and payments", "Prices and stock can change until an order is confirmed. Delivery times are estimates. Cash on delivery and other listed payment methods are accepted."],
  ["Repairs and installation", "Price estimates are confirmed by the technician on inspection. Parts and labour warranties, if any, are explained at the time of service."],
  ["Buyback", "Quotes depend on the device condition you declare. The final price is confirmed at pickup after inspection. You confirm that you own the device you sell and that it is not stolen or under finance."],
  ["Cancellations and returns", "You can cancel an order before it is dispatched. Returns follow the brand's and seller's policy for each product."],
  ["Liability", "To the extent allowed by law, Quiktronic is not liable for indirect losses. Nothing in these terms limits your rights under Indian consumer law."],
  ["Contact", `Questions about these terms: ${CONTACT}.`],
];

function LegalPage({ title, sections, testid }) {
  return (
    <div className="max-w-3xl mx-auto px-5 lg:px-8 py-14" data-testid={testid}>
      <p className="vm-overline">Quiktronic</p>
      <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tighter mt-2">{title}</h1>
      <p className="text-sm text-neutral-500 mt-3">Last updated: {UPDATED}</p>
      <div className="mt-10 space-y-8">
        {sections.map(([h, body]) => (
          <section key={h}>
            <h2 className="font-display text-lg font-bold">{h}</h2>
            <p className="text-sm md:text-base text-neutral-600 leading-relaxed mt-2">{body}</p>
          </section>
        ))}
      </div>
    </div>
  );
}

export const Privacy = () => <LegalPage title="Privacy Policy" sections={PRIVACY} testid="privacy-page" />;
export const Terms = () => <LegalPage title="Terms of Service" sections={TERMS} testid="terms-page" />;
